import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function minValidator(min = 0.001): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return (control.value || control.value === 0) && (+control.value < min) ? { min: { value: control.value } } : null;
  };
}

export function maxValidator(max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return (control.value || control.value === 0) && (+control.value > max) ? { max: { value: control.value } } : null;
  };
}
